export enum ITypeChartOptions {
    Bar = "bar",
    StackedBar = "stackedBar",
    Line = "line",
    Pie = "pie",
    Radar = "radar"
}